import AppointmentsBanner from './AppointmentsBanner';

export default AppointmentsBanner;
